import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    'filterFormModal'
  ];

  launchFilterFormModal(e) {
    const filterFormModal = this.application.getControllerForElementAndIdentifier(
      this.filterFormModalTarget,
      "modal"
    );
    filterFormModal.open();
  }
}
